import type { SiteChatLang } from './types';

/** The phone field's country picker, per widget language (see `ui.ts`). Country names come from the browser. */
export type SiteChatPhoneUi = {
    phoneSearch: string;
    phoneNoResults: string;
    phoneOneResult: string;
    /** `${count}` is replaced by the picker itself. */
    phoneResults: string;
    phoneCountry: string;
    phoneNoCountry: string;
    phoneCountries: string;
    phoneClearSearch: string;
};

export const PHONE_UI: Record<SiteChatLang, SiteChatPhoneUi> = {
    en: {
        phoneSearch: 'Search',
        phoneNoResults: 'No results',
        phoneOneResult: '1 result',
        phoneResults: '${count} results',
        phoneCountry: 'Country',
        phoneNoCountry: 'No country selected',
        phoneCountries: 'Countries',
        phoneClearSearch: 'Clear search',
    },
    ru: {
        phoneSearch: 'Поиск',
        phoneNoResults: 'Ничего не найдено',
        phoneOneResult: 'Найдена 1 страна',
        phoneResults: 'Найдено: ${count}',
        phoneCountry: 'Страна',
        phoneNoCountry: 'Страна не выбрана',
        phoneCountries: 'Страны',
        phoneClearSearch: 'Очистить поиск',
    },
    uk: {
        phoneSearch: 'Пошук',
        phoneNoResults: 'Нічого не знайдено',
        phoneOneResult: 'Знайдено 1 країну',
        phoneResults: 'Знайдено: ${count}',
        phoneCountry: 'Країна',
        phoneNoCountry: 'Країну не вибрано',
        phoneCountries: 'Країни',
        phoneClearSearch: 'Очистити пошук',
    },
    es: {
        phoneSearch: 'Buscar',
        phoneNoResults: 'Sin resultados',
        phoneOneResult: '1 resultado',
        phoneResults: '${count} resultados',
        phoneCountry: 'País',
        phoneNoCountry: 'Ningún país seleccionado',
        phoneCountries: 'Países',
        phoneClearSearch: 'Borrar búsqueda',
    },
    id: {
        phoneSearch: 'Cari',
        phoneNoResults: 'Tidak ada hasil',
        phoneOneResult: '1 hasil',
        phoneResults: '${count} hasil',
        phoneCountry: 'Negara',
        phoneNoCountry: 'Belum ada negara dipilih',
        phoneCountries: 'Daftar negara',
        phoneClearSearch: 'Hapus pencarian',
    },
    lt: {
        phoneSearch: 'Ieškoti',
        phoneNoResults: 'Nieko nerasta',
        phoneOneResult: 'Rasta: 1',
        phoneResults: 'Rasta: ${count}',
        phoneCountry: 'Šalis',
        phoneNoCountry: 'Šalis nepasirinkta',
        phoneCountries: 'Šalys',
        phoneClearSearch: 'Išvalyti paiešką',
    },
    pt: {
        phoneSearch: 'Pesquisar',
        phoneNoResults: 'Sem resultados',
        phoneOneResult: '1 resultado',
        phoneResults: '${count} resultados',
        phoneCountry: 'País',
        phoneNoCountry: 'Nenhum país selecionado',
        phoneCountries: 'Países',
        phoneClearSearch: 'Limpar pesquisa',
    },
    zhcn: {
        phoneSearch: '搜索',
        phoneNoResults: '没有结果',
        phoneOneResult: '1 个结果',
        phoneResults: '${count} 个结果',
        phoneCountry: '国家/地区',
        phoneNoCountry: '未选择国家/地区',
        phoneCountries: '国家/地区列表',
        phoneClearSearch: '清除搜索',
    },
    zhtw: {
        phoneSearch: '搜尋',
        phoneNoResults: '沒有結果',
        phoneOneResult: '1 個結果',
        phoneResults: '${count} 個結果',
        phoneCountry: '國家/地區',
        phoneNoCountry: '未選擇國家/地區',
        phoneCountries: '國家/地區清單',
        phoneClearSearch: '清除搜尋',
    },
};
